export const filtersSelector = (state) => state.filtersReducer.storedFilters;
export const provinceSelector = (state) => state.filtersReducer.currentProvince;
export const msaPhaseSelector = (state) => state.filtersReducer.msaPhase;
export const msaPauseSelector = (state) => state.filtersReducer.msaPause;
